
/* FIXCOMART - BLOGHERO PRICE + COMPARE AT PRICE */

(function () {
  const cache = new Map();

  const rupiah = (cents) =>
    "Rp" + new Intl.NumberFormat("id-ID", {
      maximumFractionDigits: 0
    }).format(cents / 100);

  function getProduct(handle) {
    if (!cache.has(handle)) {
      const root = window.Shopify?.routes?.root || "/";

      const request = fetch(
        root + "products/" + encodeURIComponent(handle) + ".js"
      )
        .then((res) => {
          if (!res.ok) throw new Error("Product unavailable");
          return res.json();
        })
        .catch((error) => {
          cache.delete(handle);
          throw error;
        });

      cache.set(handle, request);
    }

    return cache.get(handle);
  }

  function findVariant(product, block) {
    const variants = product.variants || [];

    if (variants.length === 1) {
      return variants[0];
    }

    const label = block.querySelector("#variant-display")
      ?.textContent
      .replace(/^Variant:\s*/i, "")
      .trim()
      .toLowerCase();

    if (!label) return null;

    const matches = variants.filter((v) => {
      const title = (v.title || "").toLowerCase();

      return title === label ||
        (v.options || []).some(
          (option) => option.toLowerCase() === label
        );
    });

    // Hindari menampilkan harga varian yang salah.
    return matches.length === 1 ? matches[0] : null;
  }

  async function updateCard(block) {
    const link = block.querySelector(
      'a.custom-product-button-block-title[href*="/products/"]'
    );

    const priceEl = block.querySelector("#price-display");

    if (!link || !priceEl) return;

    const match = link.getAttribute("href")
      .match(/\/products\/([^/?#]+)/);

    if (!match) return;

    const handle = decodeURIComponent(match[1]);

    try {
      const product = await getProduct(handle);

      if (!block.isConnected || !priceEl.isConnected) return;

      const variant = findVariant(product, block);
      if (!variant) return;

      const price = Number(variant.price);
      const compare = Number(variant.compare_at_price);

      if (!Number.isFinite(price)) return;

      const signature = [
        variant.id,
        price,
        compare
      ].join("-");

      if (
        priceEl.dataset.fixcoSignature === signature &&
        priceEl.querySelector(".fixco-current-price")
      ) {
        return;
      }

      const fragment = document.createDocumentFragment();

      if (compare > price) {
        const oldPrice = document.createElement("del");
        oldPrice.className = "fixco-compare-price";
        oldPrice.textContent = rupiah(compare);
        fragment.appendChild(oldPrice);
      }

      const current = document.createElement("span");
      current.className = "fixco-current-price";
      current.textContent = rupiah(price);
      fragment.appendChild(current);

      priceEl.replaceChildren(fragment);
      priceEl.dataset.fixcoSignature = signature;

    } catch (error) {
      console.warn("Fixco price:", error);
    }
  }

  let scheduled = false;

  function updateAll() {
    document.querySelectorAll(
      ".custom-product-button-block"
    ).forEach(updateCard);
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    setTimeout(() => {
      scheduled = false;
      updateAll();
    }, 150);
  }

  function init() {
    scheduleUpdate();

    // Menangani widget BlogHero yang dimuat dinamis.
    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });

    document.addEventListener("change", scheduleUpdate);
    document.addEventListener("click", scheduleUpdate);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
